import { registerPageView } from '@/plugins/helper'

export default function() {
  registerPageView()
}
